import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGcs = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("title", { children: "Google Cloud Storage" }), /* @__PURE__ */ _jsx("path", { d: "M12.19 2.38a9.344 9.344 0 0 0-9.234 6.893c.053-.02-.055.013 0 0-3.875 2.551-3.922 8.11-.247 10.941l.006-.007-.007.03a6.717 6.717 0 0 0 4.077 1.356h5.173l.03.03h5.192c6.687.053 9.376-8.605 3.835-12.35a9.365 9.365 0 0 0-2.821-4.552l-.043.043.006-.05A9.344 9.344 0 0 0 12.19 2.38zm-.358 4.146c1.244-.04 2.518.368 3.486 1.15a5.186 5.186 0 0 1 1.862 4.078v.518c3.53-.07 3.53 5.262 0 5.193h-5.193l-.008.009v-.04H6.785a2.59 2.59 0 0 1-1.067-.23h.001a2.597 2.597 0 1 1 3.437-3.437l3.013-3.012A6.747 6.747 0 0 0 8.11 8.24c.018-.01.04-.026.054-.023a5.186 5.186 0 0 1 3.67-1.69z" }));
});
export default SvgGcs;
